/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlcenterMelcoControlCenterModelsDigitizingOrderAlertAttachment
 */
export interface ControlcenterMelcoControlCenterModelsDigitizingOrderAlertAttachment {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderAlertAttachment
     */
    file_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderAlertAttachment
     */
    file_extension?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderAlertAttachment
     */
    preview_url?: string | null;
}

export function ControlcenterMelcoControlCenterModelsDigitizingOrderAlertAttachmentFromJSON(json: any): ControlcenterMelcoControlCenterModelsDigitizingOrderAlertAttachment {
    return ControlcenterMelcoControlCenterModelsDigitizingOrderAlertAttachmentFromJSONTyped(json, false);
}

export function ControlcenterMelcoControlCenterModelsDigitizingOrderAlertAttachmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoControlCenterModelsDigitizingOrderAlertAttachment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'file_name': !exists(json, 'file_name') ? undefined : json['file_name'],
        'file_extension': !exists(json, 'file_extension') ? undefined : json['file_extension'],
        'preview_url': !exists(json, 'preview_url') ? undefined : json['preview_url'],
    };
}

export function ControlcenterMelcoControlCenterModelsDigitizingOrderAlertAttachmentToJSON(value?: ControlcenterMelcoControlCenterModelsDigitizingOrderAlertAttachment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'file_name': value.file_name,
        'file_extension': value.file_extension,
        'preview_url': value.preview_url,
    };
}


